import type { PropsWithChildren } from 'react'
import { View } from 'react-native'
import { cn } from '~/lib/utils'

export function PhaseWrapper({
  children,
  footer,
  className,
  contentClassName,
}: PropsWithChildren<{
  footer?: React.ReactNode
  className?: string
  contentClassName?: string
}>) {
  return (
    <View className={cn('w-full flex-1 justify-between gap-6', className)}>
      <View className={cn('flex-1 gap-6', contentClassName)}>{children}</View>
      {!!footer && footer}
    </View>
  )
}
